import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { CCTable } from "components/ui/Table";
import FinancialAidYearContext from "components/contexts/FinancialAidYearContext";

export function AidYearSelector() {
  const navigate = useNavigate();

  const { aidYears, aidYear, setAidYear, onSummaryPage } = useContext(
    FinancialAidYearContext
  );

  const onChange = (event) => {
    setAidYear(aidYears.find((year) => year.id === event.target.value));

    if (!onSummaryPage) {
      navigate(`/finances/finaid/${event.target.value}`);
    }
  };

  return (
    <CCTable>
      <tbody>
        <tr data-testid="aid-year-select">
          <th>
            <label htmlFor="aid-year-select">Aid Year:</label>
          </th>
          <td style={{ width: `75%` }}>
            {aidYears.length === 1 ? (
              <>{aidYears[0].name}</>
            ) : (
              <select
                id="aid-year-select"
                style={{
                  backgroundColor: `var(--wild-sand)`,
                  borderRadius: "3px",
                  padding: "2px",
                }}
                value={aidYear?.id}
                onChange={onChange}
              >
                {aidYears.map((year) => (
                  <option key={year.id} value={year.id}>
                    {year.name}
                  </option>
                ))}
              </select>
            )}
          </td>
        </tr>

        {aidYear && (
          <tr data-testid="selected-semester">
            <th>Semesters:</th>
            <td>{sentenceList(aidYear.availableSemesters)}</td>
          </tr>
        )}
      </tbody>
    </CCTable>
  );
}

/**
 * sentenceList
 * Seperate items with commas and the last one with 'and'
 * ['Item 1'] => Item 1'
 * ['Item 1', 'Item 2'] => Item 1 and Item 2
 * ['Item 1', 'Item 2', 'Item 3'] => Item 1, Item 2 and Item 3
 */
function sentenceList(items) {
  if (items.length < 2) {
    return items[0];
  } else {
    return [items.slice(0, -1).join(", "), items.slice(-1)].join(" and ");
  }
}
